import { supabase } from "@/integrations/supabase/client";

type RedditEvent = 'PageVisit' | 'ViewContent' | 'Search' | 'AddToCart' | 'AddToWishlist' | 'Purchase' | 'Lead' | 'SignUp' | 'Custom';

interface TrackOptions {
  email?: string;
  externalId?: string;
  itemCount?: number;
  currency?: string;
  value?: number;
  products?: Array<{ id?: string; name?: string; category?: string }>;
}

/**
 * Fires a Reddit conversion event via both the Pixel (client) and CAPI (server).
 * Uses the same conversionId for deduplication.
 */
export async function trackRedditEvent(event: RedditEvent, options?: TrackOptions) {
  const conversionId = crypto.randomUUID();

  // 1. Fire client-side pixel event with conversionId
  if (window.rdt) {
    window.rdt('track', event, { conversionId });
  }

  // 2. Send server-side CAPI event (fire-and-forget)
  try {
    await supabase.functions.invoke('reddit-capi', {
      body: {
        event,
        conversionId,
        eventAt: Date.now(),
        email: options?.email,
        externalId: options?.externalId,
        userAgent: navigator.userAgent,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        itemCount: options?.itemCount,
        currency: options?.currency,
        value: options?.value,
        products: options?.products,
      },
    });
  } catch {
    // Don't fail the user flow if CAPI tracking fails
  }
}
